<template>
  <b-modal id="tacacs-password-modal"
    v-model="visible"
    title="TACACS Password"
    centered
    @show="reset"
    @hidden="reset"
    @ok="handleOK">
    <b-form class="my-4"
      @submit.prevent="handleSubmit">
      <b-form-group label="Enter new password"
        label-for="password-input"
        :invalid-feedback="passwordFeedback"
        :state="passwordState">
        <b-form-input id="password-input"
          ref="passwordInput"
          v-model="password"
          type="password"
          :state="passwordState" />
      </b-form-group>

      <b-form-group label="Repeat new password"
        label-for="repeated-input"
        :invalid-feedback="repeatedFeedback"
        :state="repeatedState">
        <b-form-input id="repeated-input"
          ref="repeatedInput"
          v-model="repeated"
          type="password"
          :state="repeatedState" />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { cryptSha512 } from '@/utils/crypt'

export default {
  name: 'UserTacacsPasswordModal',

  emits: ['change-tacacs-password'],

  data() {
    return {
      visible: false,
      password: '',
      repeated: '',
      passwordFeedback: null,
      repeatedFeedback: null,
      validated: false,
    }
  },

  computed: {
    passwordState() {
      return this.validated && this.passwordFeedback ? false : null
    },
    repeatedState() {
      return this.validated && this.repeatedFeedback ? false : null
    },
  },

  methods: {
    show() {
      this.visible = true
      window.setTimeout(() => {
        this.$refs.passwordInput.focus()
      }, 100)
    },
    hide() {
      this.visible = false
    },
    reset() {
      this.validated = false
      this.password = ''
      this.repeated = ''
      this.passwordFeedback = null
      this.repeatedFeedback = null
    },
    handleOK(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.handleSubmit()
    },
    handleSubmit() {
      this.passwordFeedback = null
      this.repeatedFeedback = null
      this.validated = true
      let toFocus = null

      if (this.repeated !== this.password) {
        this.repeatedFeedback = 'Passwords differ'
        toFocus = this.$refs.repeatedInput
      }

      if (this.password.length < 8 || this.password.length > 100) {
        this.passwordFeedback = 'Password must be 8-100 characters'
        toFocus = this.$refs.passwordInput
      }

      if (this.passwordFeedback || this.repeatedFeedback) {
        if (toFocus) {
          toFocus.focus()
          window.setTimeout(() => {
            toFocus.focus()
          }, 100)
        }
        return
      }

      const passwordHash = cryptSha512(this.password)
      if (!passwordHash) {
        this.$bvToast.toast('Failed to calculate password hash', {
          title: 'TACACS Password',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true,
          noCloseButton: false,
          toaster: 'b-toaster-top-right',
        })
        return
      }

      this.$emit('change-tacacs-password', { passwordHash })
      this.$nextTick(() => {
        this.visible = false
      })
    },
  },
}
</script>
